import { Box, Button, Center, Flex, Text } from "@chakra-ui/react";
import { Poem, poems } from "./poems";
import { useState } from "react";
import { IoIosArrowDropleftCircle } from "react-icons/io";
import { IoIosArrowDroprightCircle } from "react-icons/io";

export const Poetry = () => {
  const [selectedPoem, setSelectedPoem] = useState<Poem>(poems[0]);

  function navigateIndex(
    currentIndex: number,
    arrayLength: number,
    direction: "next" | "prev"
  ): number {
    if (direction === "next") {
      setSelectedPoem(poems[(currentIndex + 1) % arrayLength]); // loops forward
    }
    if (direction === "prev") {
      setSelectedPoem(poems[(currentIndex - 1 + arrayLength) % arrayLength]); // loops backward
    }
    return currentIndex; // fallback
  }

  return (
    <Box px={3}>
      <Flex
        flexWrap={"wrap"}
        gap={3}
        justifyContent="center"
        maxW="1300px"
        m="0 auto"
      >
        {poems.map((poem) => (
          <Button
            size="sm"
            variant="link"
            whiteSpace="break-spaces"
            px={5}
            py={2}
            onClick={() => setSelectedPoem(poem)}
            isDisabled={selectedPoem === poem}
            cursor="pointer"
            color="#248dc5ff"
            borderRadius="25px"
            border="1px solid #248dc5ff"
            _disabled={{
              cursor: "default",
              textDecoration: "none",
              color: "#adadadff",
              border: "1px solid transparent",
            }}
          >
            {poem.title}
          </Button>
        ))}
      </Flex>
      {selectedPoem ? (
        <Box height="100%" maxW="1300px" m="50px auto" px={5}>
          <Flex w="100%">
            <Button
              cursor="pointer"
              p={30}
              onClick={() =>
                navigateIndex(poems.indexOf(selectedPoem), poems.length, "prev")
              }
            >
              <IoIosArrowDropleftCircle size={25} />
            </Button>
            <Box w="100%">
              <Text w="100%" textAlign="center" fontSize="25px">
                {selectedPoem?.title}
              </Text>
              <Text w="100%" textAlign="center" fontSize="15px">
                {selectedPoem?.created}
              </Text>
            </Box>

            <Button
              cursor="pointer"
              padding={15}
              p={30}
              onClick={() =>
                navigateIndex(poems.indexOf(selectedPoem), poems.length, "next")
              }
            >
              <IoIosArrowDroprightCircle size={25} />
            </Button>
          </Flex>

          <Center w="100%">
            <Text p={35} whiteSpace="pre-line">
              {selectedPoem?.content}
            </Text>
          </Center>
        </Box>
      ) : (
        <Center>
          <Text>Loading...</Text>
        </Center>
      )}
    </Box>
  );
};
